@if(isModalOpen()){
    @for(modal of modalService.modals(); track $index; let last = $last){
      <div [@enterAnimation] 
      class="modals-wrapper" 
      [ngStyle]="{'z-index': 'calc(var(--overlay-z-index) + '+($index+1)+')'}" 
      [ngClass]="{ 'with-header': isWithHeader(modal.name), 'bottom-align': isWithBottomAlign(modal.name), 'no-pointer-events': modal.name === modalName.OrderTreeNotification}"
      tabindex="-1"
      role="dialog"
      cdkTrapFocus
      [attr.aria-modal]="last ? 'true' : 'false'"
      [attr.aria-label]="modal.name"
      [attr.aria-hidden]="!last ? 'true' : null"
      [attr.inert]="!last ? '' : null"
      #modalContainer
      >
        <div
        class="modals-content"
        [ngClass]="getModalClassAnimation(modal.name)"
        [class.with-generic-modal]="modal.name === modalName.Generic"
        [class.with-image-preview]="modal.name === modalName.ImagePreview"
        [ngStyle]="{
            'z-index': 'calc(var(--modal-content-z-index) + '+($index+2)+')',
            'max-width': modal.name === modalName.SMSOffer && stateForModal(modalName.SMSOffer)?.coupon?.coupon.imageUrl ? '820px' : (modal.name === modalName.PremiumPromo ? '51.5rem' : ''),
        }"
        >

        @switch(modal.name){
          @case(modalName.OrderDetails){
            @defer (on immediate){
              <cwo-order-details-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.MobileSideNav){
            @defer (on immediate){
              <cwo-mobile-nav-menu cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.Cart){
            @defer (on immediate){
              <cwo-cart cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.ItemEditor){
            @defer (on immediate){
              <cwo-item-editor cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.SpecialItemEditor){
            @defer (on immediate){
              <cwo-special-item-editor cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.SignIn){
            @defer (on immediate){
              <cwo-signing-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.EditWallet){
            @defer (on immediate){
              <cwo-edit-wallet-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.AddWallet){
            @defer (on immediate){
              <cwo-add-wallet-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.EditAddress){
            @defer (on immediate){
              <cwo-edit-address-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.AddAddress){
            @defer (on immediate){
              <cwo-add-address-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.AddCoupon){
            @defer (on immediate){
              <cwo-add-coupon-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.VerifyEmail){
            @defer (on immediate){
              <cwo-verify-email-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.CouponConfirmation){
            @defer (on immediate){
              <cwo-coupon-confirmation-modal [couponConfirmationInstructionsModalTemplateRef]="couponConfirmationInstructionsModalTemplateRef()" cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.ImagePreview){
            @defer (on immediate){
              <cwo-image-preview-modal class="image-preview-content" cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.OrderTreeNotification){
            @defer (on immediate){
              <cwo-order-tree-notification-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.Generic){
            <cwo-generic-modals class="generic-modal" />
          } 
          @case(modalName.SMSOffer){
            @defer (on immediate){
              <cwo-sms-offer-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.SurveySubmittedLinks){
            @defer (on immediate){
              <cwo-completed-survey-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.ForcedChoice){
            <cwo-forced-choice-modals />
          }
          @case(modalName.FundraiserSponsors){
            @defer (on immediate){
              <cwo-fundraiser-sponsors-modal cwoModalAutoFocus></cwo-fundraiser-sponsors-modal>
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.CancelSubscription){
            @defer (on immediate){
              <cwo-cancel-subscription-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.ReactivateSubscription){
            @defer (on immediate){
              <cwo-reactivate-subscription-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.EnjoySurvey){
            @defer (on immediate){
              <cwo-modal-survey-checkout cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
          @case(modalName.PremiumPromo){
            @defer (on immediate){
              <cwo-premium-promo-modal cwoModalAutoFocus />
            }
            @loading {
              <div class="modal-loading" role="status">
                <cwo-dots-loader />
              </div>
            }
          }
        }
      </div>
      @if(modal.name !== modalName.OrderTreeNotification && modal.name !== modalName.EnjoySurvey){
        <div class="overlay-background" (click)="handleBackdropClick(modal.name)" (keydown)="handleEscapeKey()" aria-hidden="true"></div>
      }
      @if(modal.name === modalName.EnjoySurvey){
        <div class="overlay-background" aria-hidden="true"></div>
      }
    </div>
    }
  }

  @defer (when false; prefetch on idle) {
    <cwo-order-details-modal />
    <cwo-mobile-nav-menu />
    <cwo-cart />
    <cwo-item-editor />
    <cwo-special-item-editor />
    <cwo-signing-modal />
    <cwo-edit-wallet-modal />
    <cwo-add-wallet-modal />
    <cwo-edit-address-modal />
    <cwo-add-address-modal />
    <cwo-add-coupon-modal />
    <cwo-verify-email-modal />
    <cwo-coupon-confirmation-modal />
    <cwo-image-preview-modal />
    <cwo-order-tree-notification-modal />
    <cwo-sms-offer-modal />
    <cwo-completed-survey-modal />
    <cwo-fundraiser-sponsors-modal />
    <cwo-cancel-subscription-modal />
    <cwo-reactivate-subscription-modal />
    <cwo-modal-survey-checkout />
    <cwo-premium-promo-modal />
  }

  <ng-template #couponConfirmationInstructionsModal>
    <div class="coupon-confirmation-container">
      <span class="pending-special-name">{{orderService.order().pendingSpecial?.name}}</span>
      <span class="pending-special-instructions">{{orderService.order().pendingSpecial?.instructions}}</span>
    </div>
  </ng-template>
